import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import air from '../../../Assets/Plane-icon-red.png';
import ship from '../../../Assets/Ship-icon-red.png';
import Truck from '../../../Assets/Truck-icon-red.png';
import './Formtable.css';
import { toast } from "react-toastify";

import { toAbsoluteUrl } from "../../../_metronic/helpers";

interface Customer {
    name: string;
    mobile: string;
    address?: string;
    [key: string]: any;
}

interface Booking {
    booking_id: string;
    consignor: string;
    consignee: string;
    consignor_address: string;
    consignee_address: string;
    who_paid: string;
    shipment_mode: string;
    description: string;
    invoice_value: number;
    booking_mode: string;
    notes: string;

    // Normal booking fields
    nrml_payment_quantity: number;

    // Split booking fields
    large_box_quantity: number;
    medium_box_quantity: number;
    small_box_quantity: number;
    total_quantity: number;

    // Payment fields
    consignor_payment_status: string;
    payment_mode: string;

    // Piece Rate Method
    total_pieces: number;
    piece_value: number;

    // CBM Rate Method
    cbm_value: number;
    cbm_price: number;

    // Invoice Value Method
    invoice_percentage: number;

    // AS_per_Booking_type fields
    nrml_quantity_price: number;
    large_unit_price: number;
    medium_unit_price: number;
    small_unit_price: number;

    total_price: number;
    payment_status: string;
    total_amount: number;

    shipment_status: string;
    [key: string]: any;
}

interface BookingEditProps {
    booking: Booking;
    onClose: () => void;
    onUpdateSuccess: (params: { statuses?: string[]; createdDateFrom?: Date; createdDateTo?: Date }) => void;
}


const BookingEdit: React.FC<BookingEditProps> = ({ booking, onClose, onUpdateSuccess }) => {
    const [totalAmountInput, setTotalAmountInput] = useState('');
    console.log("booking edit", booking)
    const [formData, setFormData] = useState<Booking>({
        booking_id: booking.booking_id || "",
        consignor: booking.consignor || "",
        consignee: booking.consignee || "",
        consignor_address: booking.consignor_address || "",
        consignee_address: booking.consignee_address || "",
        who_paid: booking.who_paid || "",
        customer_id: booking.customer_id || '',
        shipment_mode: booking.shipment_mode || "",
        description: booking.description || "",
        invoice_value: booking.invoice_value || 0,
        booking_mode: booking.booking_mode || "",
        notes: booking.notes || "",
        nrml_payment_quantity: booking.nrml_payment_quantity || 0,
        large_box_quantity: booking.large_box_quantity || 0,
        medium_box_quantity: booking.medium_box_quantity || 0,
        small_box_quantity: booking.small_box_quantity || 0,
        total_quantity: booking.total_quantity || 0,
        consignor_payment_status: booking.consignor_payment_status || "",
        payment_mode: booking.payment_mode || "",
        total_pieces: booking.total_pieces || 0,
        piece_value: booking.piece_value || 0,
        cbm_value: booking.cbm_value || 0,
        cbm_price: booking.cbm_price || 0,
        invoice_percentage: booking.invoice_percentage || 0,
        nrml_quantity_price: booking.nrml_quantity_price || 0,
        large_unit_price: booking.large_unit_price || 0,
        medium_unit_price: booking.medium_unit_price || 0,
        small_unit_price: booking.small_unit_price || 0,
        total_price: booking.total_price || 0,
        payment_status: booking.payment_status || "",
        total_amount: booking.total_amount || 0,
        shipment_status: booking.shipment_status || "",
    });

    const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [isTotalAmountEdited, setIsTotalAmountEdited] = useState<boolean>(false);

    const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (booking) {
            setFormData(booking);
            fetchCustomers()
        }
    }, [booking]);

    useEffect(() => {
        if (formData) {
            let updatedTotalPrice = 0;

            switch (formData.payment_mode) {
                case "Piece Rate Method":
                    updatedTotalPrice = formData.total_pieces_price || 0;
                    break;
                case "CBM Rate Method":
                    updatedTotalPrice = formData.total_cbm_price || 0;
                    break;
                case "Invoice Value Method":
                    updatedTotalPrice = formData.total_invoice_price || 0;
                    break;
                case "Splitted Unit Price Method":
                    updatedTotalPrice = formData.split_total_price || 0;
                    break;
                case "Normal Unit Price Method":
                    updatedTotalPrice = formData.nrml_qty_total_price || 0;
                    break;
                default:
                    updatedTotalPrice = 0;
                    break;
            }

            // ✅ Only update total_price if it is 0 or uninitialized to prevent overwriting
            if (formData.total_price === 0 || formData.total_price === undefined) {
                setFormData(prevState => ({
                    ...prevState,
                    total_price: updatedTotalPrice,
                    // total_amount: prevState.payment_status === "Yes" ? updatedTotalPrice : 0,
                }));
            }
        }
    }, [
        formData.payment_mode,
        formData.nrml_qty_total_price,
        formData.total_cbm_price,
        formData.total_invoice_price,
        formData.split_total_price,
        formData.payment_status,
    ]);

    // When payment status changes to Yes, set the initial value:
    useEffect(() => {
        if (formData.payment_status === 'Yes') {
            const totalPrice = parseFloat(formData.total_price as any);
            if (!isNaN(totalPrice)) {
                setTotalAmountInput(totalPrice.toFixed(2));
            } else {
                setTotalAmountInput('');
            }
        } else {
            setTotalAmountInput('');
        }
    }, [formData.payment_status, formData.total_price]);

    const fetchCustomers = async () => {
        try {
            // setLoading(true);
            const response = await fetch(
                "https://backendcway.causewaycargo.com/superadmin/getallcustomersdetails",
                {
                    method: "GET",
                    headers: {
                        auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            if (result.status === "success") {
                console.log("Fetched customers:", result.data);
                setCustomers(result.data);
                setError(null);
            } else {
                throw new Error("Failed to fetch data");
            }
        } catch (err) {
            if (err instanceof Error) {
                setError(`Error: ${err.message}`);
            } else {
                setError("An unknown error occurred");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        setFormData((prevState) => {
            const updatedState = { ...prevState };

            // Prevent Consignor and Consignee from being the same
            if ((name === "consignor" && value === prevState.consignee) ||
                (name === "consignee" && value === prevState.consignor)) {
                toast.error("Consignor and Consignee cannot be the same.");
                return prevState;
            }

            // Restrict Payment Mode Selection based on Booking Mode
            if (name === "payment_mode") {
                if (updatedState.booking_mode === "normal booking" && value === "Splitted Unit Price Method") {
                    toast.error("You can only select 'Normal Unit Price Method' for Normal Booking.");
                    return prevState;
                }
                if (updatedState.booking_mode === "split booking" && value === "Normal Unit Price Method") {
                    toast.error("You can only select 'Splitted Unit Price Method' for Split Booking.");
                    return prevState;
                }

                // ✅ Now do your validation here
                if (
                    updatedState.who_paid === "Consignor" &&
                    updatedState.consignor_payment_status === "Pay Now" &&
                    value === ""
                ) {
                    toast.error("Payment Mode is required when Consignor pays now.");
                    return prevState;
                }
            }

            // Convert numeric fields properly (allow empty string for user input)
            const numericFields = [
                "large_box_quantity", "medium_box_quantity", "small_box_quantity",
                "total_pieces", "piece_value", "cbm_value", "cbm_price",
                "invoice_value", "invoice_percentage", "nrml_payment_quantity",
                "nrml_quantity_price", "large_unit_price", "medium_unit_price", "small_unit_price",
                "nrml_qty_total_price", "total_cbm_price", "total_invoice_price", "split_total_price"
            ];

            if (numericFields.includes(name)) {
                updatedState[name] = value === "" ? "" : parseFloat(value) || 0; // Retain empty string for user input
            } else {
                updatedState[name] = value;
            }

            if (name === 'booking_mode') {
                if (value === 'split booking') {
                    updatedState.nrml_payment_quantity = 0; // Clear this when switching to split booking
                } else if (value === 'normal booking') {
                    // Optionally clear the split fields when switching to normal booking
                    updatedState.large_box_quantity = 0;
                    updatedState.medium_box_quantity = 0;
                    updatedState.small_box_quantity = 0;
                }
            }


            if (name === "booking_mode") {
                if (prevState.booking_mode === "Normal" && value === "Split Booking") {
                    updatedState.nrml_payment_quantity = 0;
                }
                if (prevState.booking_mode === "Split Booking" && value === "Normal") {
                    updatedState.large_box_quantity = 0;
                    updatedState.medium_box_quantity = 0;
                    updatedState.small_box_quantity = 0;
                }

                // ✅ Reset incompatible payment_mode
                const bookingValue = value.toLowerCase();

                if (
                    bookingValue === "normal booking" &&
                    updatedState.payment_mode === "Splitted Unit Price Method"
                ) {
                    toast.error("Splitted Unit Price Method is not allowed for Normal Booking. Please select a valid payment mode.");
                    updatedState.payment_mode = "";
                }

                if (
                    bookingValue === "split booking" &&
                    updatedState.payment_mode === "Normal Unit Price Method"
                ) {
                    toast.error("Normal Unit Price Method is not allowed for Split Booking. Please select a valid payment mode.");
                    updatedState.payment_mode = "";
                }
            }

            // ✅ Update total_quantity based on booking mode
            if (updatedState.booking_mode === "normal booking") {
                updatedState.total_quantity = updatedState.nrml_payment_quantity || 0;
            } else if (updatedState.booking_mode === "split booking") {
                updatedState.total_quantity =
                    (updatedState.large_box_quantity || 0) +
                    (updatedState.medium_box_quantity || 0) +
                    (updatedState.small_box_quantity || 0);
            }

            // if (updatedState.who_paid === "Consignor" && updatedState.consignor_payment_status === "Pay Now") {
            //     if (!updatedState.payment_mode) {
            //         toast.error("Payment Mode is required when Consignor pays now.");
            //         return prevState;
            //     }
            // }


            // Calculate total price based on payment mode
            switch (updatedState.payment_mode) {
                case "Piece Rate Method":
                    updatedState.total_price = (updatedState.total_pieces || 0) * (updatedState.piece_value || 0);
                    break;
                case "CBM Rate Method":
                    updatedState.total_price = (updatedState.cbm_value || 0) * (updatedState.cbm_price || 0);
                    break;
                case "Invoice Value Method":
                    updatedState.total_price = ((updatedState.invoice_value || 0) * (updatedState.invoice_percentage || 0)) / 100;
                    break;
                case "Splitted Unit Price Method":
                    updatedState.total_price =
                        (updatedState.large_box_quantity || 0) * (updatedState.large_unit_price || 0) +
                        (updatedState.medium_box_quantity || 0) * (updatedState.medium_unit_price || 0) +
                        (updatedState.small_box_quantity || 0) * (updatedState.small_unit_price || 0);
                    break;
                case "Normal Unit Price Method":
                    updatedState.total_price = (updatedState.nrml_payment_quantity || 0) * (updatedState.nrml_quantity_price || 0);
                    break;
                default:
                    updatedState.total_price = 0;
                    break;
            }

            // Update total_amount if payment_status is 'Yes'
            updatedState.total_amount = updatedState.payment_status === "Yes" ? updatedState.total_price || 0 : 0;

            console.log("Updated State:", updatedState);
            return updatedState;
        });
    };

    const handleShipmentModeChange = (mode: string) => {
        setFormData(prev => ({
            ...prev,
            shipment_mode: mode
        }));
    };


    const handleEditBooking = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);

        try {
            // Validate required fields
            if (!formData.consignor) {
                toast.error("Please select a consignor.");
                setLoading(false);
                return;
            }

            if (!formData.consignee) {
                toast.error("Please select a consignee.");
                setLoading(false);
                return;
            }

            if (!formData.shipment_mode) {
                toast.error("Please select a shipment mode.");
                setLoading(false);
                return;
            }

            if (
                formData.who_paid === 'Consignor' &&
                formData.consignor_payment_status === 'Pay Now' &&
                !formData.payment_mode
            ) {
                toast.error("Please select Payment Mode");
            }

            if (!formData.invoice_value || Number(formData.invoice_value) <= 0) {
                toast.error("Invoice Value is required and must be greater than 0 for Invoice Value Method.");
                setLoading(false);
                return;
            }


            if (
                formData.booking_mode === "normal booking" &&
                (!formData.nrml_payment_quantity || Number(formData.nrml_payment_quantity) <= 0)
            ) {
                toast.error("Normal payment quantity is required and must be greater than 0 for Normal booking.");
                setLoading(false);
                return;
            }

            if (formData.booking_mode === "split booking" &&
                !formData.large_box_quantity && !formData.medium_box_quantity && !formData.small_box_quantity) {
                toast.error("At least one box quantity must be provided for Split booking.");
                setLoading(false);
                return;
            }

            // Unit price validation
            if (formData.payment_mode) {
                if (formData.payment_mode === "Piece Rate Method") {
                    if (!formData.piece_value || Number(formData.piece_value) <= 0) {
                        toast.error("Please enter a valid piece price (greater than 0).");
                        setLoading(false);
                        return;
                    }
                    if (!formData.total_pieces || Number(formData.total_pieces) <= 0) {
                        toast.error("Please enter a valid total pieces count (greater than 0).");
                        setLoading(false);
                        return;
                    }
                }

                if (formData.payment_mode === "CBM Rate Method") {
                    if (!formData.cbm_value || Number(formData.cbm_value) <= 0) {
                        toast.error("Please enter CBM value.");
                        setLoading(false);
                        return;
                    }
                    if (!formData.cbm_price || Number(formData.cbm_price) <= 0) {
                        toast.error("Please enter CBM price.");
                        setLoading(false);
                        return;
                    }
                }

                if (formData.payment_mode === "Invoice Value Method") {
                    if (!formData.invoice_percentage || Number(formData.invoice_percentage) <= 0) {
                        toast.error("Please enter invoice percentage.");
                        setLoading(false);
                        return;
                    }
                }

                if (formData.payment_mode === "Normal Unit Price Method") {
                    if (!formData.nrml_quantity_price || Number(formData.nrml_quantity_price) <= 0) {
                        toast.error("Please enter normal booking quantity price.");
                        setLoading(false);
                        return;
                    }
                }
                if (formData.payment_mode === "Splitted Unit Price Method") {
                    const largeQty = Number(formData.large_box_quantity);
                    const mediumQty = Number(formData.medium_box_quantity);
                    const smallQty = Number(formData.small_box_quantity);

                    const largePrice = Number(formData.large_unit_price);
                    const mediumPrice = Number(formData.medium_unit_price);
                    const smallPrice = Number(formData.small_unit_price);

                    // Large box validation
                    if (largeQty > 0 && (!formData.large_unit_price || largePrice <= 0)) {
                        toast.error("Please enter valid large unit price (greater than 0).");
                        setLoading(false);
                        return;
                    }
                    if (largeQty === 0 && largePrice > 0) {
                        toast.error("Large unit price should be empty or 0 when quantity is 0.");
                        setLoading(false);
                        return;
                    }

                    // Medium box validation
                    if (mediumQty > 0 && (!formData.medium_unit_price || mediumPrice <= 0)) {
                        toast.error("Please enter valid medium unit price (greater than 0).");
                        setLoading(false);
                        return;
                    }
                    if (mediumQty === 0 && mediumPrice > 0) {
                        toast.error("Medium unit price should be empty or 0 when quantity is 0.");
                        setLoading(false);
                        return;
                    }

                    // Small box validation
                    if (smallQty > 0 && (!formData.small_unit_price || smallPrice <= 0)) {
                        toast.error("Please enter valid small unit price (greater than 0).");
                        setLoading(false);
                        return;
                    }
                    if (smallQty === 0 && smallPrice > 0) {
                        toast.error("Small unit price should be empty or 0 when quantity is 0.");
                        setLoading(false);
                        return;
                    }
                }

            }

            // const customer_id =
            //     formData.who_paid === "Consignor"
            //         ? formData.consignor_id || ""
            //         : formData.consignee_id || "";

            // console.log("Consignor ID:", formData.consignor_id);
            // console.log("Consignee ID:", formData.consignee_id);

            // Create payload with only required fields
            const payloadToSend = {
                booking_id: formData.booking_id,
                consignor: formData.consignor,
                consignor_phoneno: formData.consignor_phoneno,
                consignee_phoneno: formData.consignee_phoneno,
                customer_id: formData.customer_id,
                consignor_address: formData.consignor_address,
                consignee: formData.consignee,
                consignee_address: formData.consignee_address,
                who_paid: formData.who_paid,
                booking_mode: formData.booking_mode,
                payment_status: formData.payment_status,
                payment_mode: formData.payment_mode || "",
                consignor_payment_status: formData.consignor_payment_status,
                shipment_mode: formData.shipment_mode,
                notes: formData.notes,
                description: formData.description,
                total_quantity: Number(formData.total_quantity),
                nrml_payment_quantity: Number(formData.nrml_payment_quantity),
                nrml_quantity_price: Number(formData.nrml_quantity_price),
                nrml_qty_total_price: Number(formData.total_price),
                cbm_price: Number(formData.cbm_price),
                cbm_value: Number(formData.cbm_value),
                total_cbm_price: Number(formData.total_price),
                invoice_value: Number(formData.invoice_value),
                invoice_percentage: Number(formData.invoice_percentage),
                total_invoice_price: Number(formData.total_price),
                total_pieces: Number(formData.total_pieces),
                piece_value: Number(formData.piece_value),
                total_pieces_price: Number(formData.total_price),
                large_box_quantity: Number(formData.large_box_quantity),
                medium_box_quantity: Number(formData.medium_box_quantity),
                small_box_quantity: Number(formData.small_box_quantity),
                large_unit_price: Number(formData.large_unit_price),
                medium_unit_price: Number(formData.medium_unit_price),
                small_unit_price: Number(formData.small_unit_price),
                large_total_price: formData.large_total_price || 0,
                medium_total_price: formData.medium_total_price || 0,
                small_total_price: formData.small_total_price || 0,
                split_total_price: Number(formData.total_price),
                booking_value: Number(formData.total_price),
                total_amount: formData.payment_status === 'Yes' ? Number(formData.total_amount || formData.total_price) : 0,
                phone_no: formData.phone_no
            };

            if (formData.who_paid === "Consignor" && formData.consignor_payment_status === "Pay Later") {
                payloadToSend.payment_mode = "";
                payloadToSend.total_pieces = 0;
                payloadToSend.cbm_value = 0;
                payloadToSend.split_total_price = 0;
                payloadToSend.total_cbm_price = 0;
                payloadToSend.total_invoice_price = 0;
                payloadToSend.total_pieces_price = 0;
                payloadToSend.nrml_qty_total_price = 0;
                payloadToSend.piece_value = 0;
                payloadToSend.cbm_price = 0;
                payloadToSend.invoice_percentage = 0;
                payloadToSend.nrml_quantity_price = 0;
                payloadToSend.large_unit_price = 0;
                payloadToSend.medium_unit_price = 0;
                payloadToSend.small_unit_price = 0;
                payloadToSend.total_amount = 0;
                payloadToSend.payment_status = "No";
            }


            // if (formData.payment_mode === "AS_per_Booking_type") {
            //     payloadToSend.payment_mode =
            //         formData.booking_mode === "normal booking"
            //             ? "Normal Unit Price Method"
            //             : formData.booking_mode === "split booking"
            //                 ? "Splitted Unit Price Method"
            //                 : "";
            // } else {
            //     payloadToSend.payment_mode = formData.payment_mode || "";
            // }

            if (formData.who_paid === "Consignor" && formData.consignor_payment_status === "Pay Now") {
                if (!payloadToSend.payment_mode) {
                    toast.error("Please select a payment mode.");
                    setLoading(false);
                    return;
                }

                if (payloadToSend.payment_mode === "Piece Rate Method" && !payloadToSend.total_pieces) {
                    toast.error("Total pieces cannot be empty for Piece Rate Method.");
                    setLoading(false);
                    return;
                }
                if (payloadToSend.payment_mode === "CBM Rate Method" && !payloadToSend.cbm_value) {
                    toast.error("CBM value cannot be empty for CBM Rate Method.");
                    setLoading(false);
                    return;
                }
                if (payloadToSend.payment_mode === "Invoice Value Method" && !payloadToSend.invoice_value) {
                    toast.error("Invoice value cannot be empty for Invoice Value Method.");
                    setLoading(false);
                    return;
                }
                if (payloadToSend.payment_mode === "Normal Unit Price Method") {
                    if (formData.booking_mode === "normal booking" && !payloadToSend.nrml_payment_quantity) {
                        toast.error("Normal payment quantity cannot be empty for Normal booking.");
                        setLoading(false);
                        return;
                    }
                } else if (payloadToSend.payment_mode === "Splitted Unit Price Method") {
                    if (
                        !payloadToSend.large_box_quantity &&
                        !payloadToSend.medium_box_quantity &&
                        !payloadToSend.small_box_quantity
                    ) {
                        toast.error("At least one box quantity must be provided for Split booking.");
                        setLoading(false);
                        return;
                    }
                }
            }


            console.log("Final Payload:", payloadToSend);

            const response = await fetch(
                "https://backendcway.causewaycargo.com/superadmin/editbookingnotsplitid",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        auth: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Nywicm9sZSI6InN1cGVyX2FkbWluIiwiaWF0IjoxNzI2ODM0MzIwfQ.edXyvu0znbVoi5KU3iL8FPww3qe8LMU0oXOCwdZi8do",
                    },
                    body: JSON.stringify(payloadToSend),
                }
            );

            if (response.ok) {
                toast.success("Booking updated successfully!");
                onClose()
                onUpdateSuccess({});
            } else {
                const errorData = await response.json();
                toast.error(errorData.message || "Failed to update booking.");
            }
        } catch (error) {
            console.error("Error updating booking:", error);
            toast.error("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    // ✅ Make sure this function is called on form submit
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await handleEditBooking(e);
    };


    // const handleCloseSuccessModal = () => {
    //     setShowSuccessModal(false);
    //     onClose();
    // };


    return (
        <>
            <div className='modal-backdrop shadow-lg rounded-5'>
                <div className='modal d-block' tabIndex={-1} role='dialog'>
                    <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: '1440px' }}>
                        <div className="modal-content shadow-lg rounded-5">
                            <div className="modal-header d-flex justify-content-between align-items-center bg-light py-4 px-4 border-bottom">
                                <div className="d-flex align-items-center gap-3">
                                    <span className="fs-2 fw-bold text-primary">
                                        <i className="bi bi-pencil-square fs-2 me-2"></i>
                                        Edit Booking
                                    </span>
                                    <span className="badge bg-primary-subtle fs-2 text-primary px-3 py-2 rounded-pill">
                                        ID: {formData.booking_id}
                                    </span>
                                </div>
                                <button type="button" className="btn-close" onClick={onClose}></button>
                            </div>

                            <div className="modal-body" style={{ maxHeight: "80vh", overflow: "auto" }}>
                                <div className='card'>
                                    <div className='card-body'>
                                        <form onSubmit={handleSubmit}>
                                            <div className="row mb-6">
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="consignor" className="form-label">
                                                        Consignor <span className="text-danger">*</span>
                                                    </label>
                                                    <Select
                                                        value={customers.find((c) => c.name === formData?.consignor) || null}
                                                        onChange={(selectedOption: any) =>
                                                            handleInputChange({
                                                                target: { name: "consignor", value: selectedOption?.name || "" },
                                                            } as unknown as React.ChangeEvent<HTMLInputElement>)
                                                        }
                                                        onFocus={fetchCustomers}
                                                        getOptionLabel={(customer: any) => `${customer.name} (${customer.mobile})`}
                                                        getOptionValue={(customer: any) => customer.name}
                                                        options={customers as Customer[]}
                                                    />
                                                    {error && <p className="text-danger mt-2">{error}</p>}
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="consignee" className="form-label">Consignee <span className="text-danger">*</span></label>
                                                    <Select
                                                        value={customers.find((c) => c.name === formData?.consignee) || null}
                                                        onChange={(selectedOption: any) =>
                                                            handleInputChange({
                                                                target: { name: "consignee", value: selectedOption?.name || "" },
                                                            } as unknown as React.ChangeEvent<HTMLInputElement>)
                                                        }
                                                        onFocus={fetchCustomers}
                                                        getOptionLabel={(customer: any) => `${customer.name} (${customer.mobile})`}
                                                        getOptionValue={(customer: any) => customer.name}
                                                        options={customers as Customer[]}
                                                    />
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="who_paid" className="form-label">Payment Mode <span className="text-danger">*</span></label>
                                                    <select
                                                        className="form-select"
                                                        id="who_paid"
                                                        name="who_paid"
                                                        value={formData.who_paid}
                                                        onChange={handleInputChange}
                                                        required
                                                    // disabled={!!formData.who_paid}
                                                    >
                                                        <option value="" disabled>Select Payment</option>
                                                        <option value="Consignor">Consignor Payment</option>
                                                        <option value="Consignee">Consignee Payment</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row mb-6">
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="consignor_address" className="form-label">Consignor Address <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="consignor_address"
                                                        name="consignor_address"
                                                        value={formData.consignor_address}
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="consignee_address" className="form-label">Consignee Address <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="consignee_address"
                                                        name="consignee_address"
                                                        value={formData.consignee_address}
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="shipment_mode" className="form-label">Shipment Mode <span className="text-danger">*</span></label>
                                                    <div className="d-flex align-items-center">
                                                        <div className="shipment-option me-3" onClick={() => handleShipmentModeChange('air')}>
                                                            <img
                                                                src={air}
                                                                alt="Air"
                                                                className={`shipment-image ${formData.shipment_mode === 'air' ? 'selected' : ''}`}

                                                            />
                                                            <p className='mb-0'>Air</p>
                                                        </div>
                                                        <div className="shipment-option me-3" onClick={() => handleShipmentModeChange('sea')}>
                                                            <img
                                                                src={ship}
                                                                alt="Sea"
                                                                className={`shipment-image ${formData.shipment_mode === 'sea' ? 'selected' : ''}`}

                                                            />
                                                            <p className='mb-0'>Sea</p>
                                                        </div>
                                                        <div className="shipment-option" onClick={() => handleShipmentModeChange('land')}>
                                                            <img
                                                                src={Truck}
                                                                alt="Land"
                                                                className={`shipment-image ${formData.shipment_mode === 'land' ? 'selected' : ''}`}

                                                            />
                                                            <p className='mb-0'>Land</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mb-6">
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="description" className="form-label">Description <span className="text-danger">*</span></label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="description"
                                                        name="description"
                                                        required
                                                        value={formData.description}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="invoice_value" className="form-label">
                                                        Invoice Value <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="invoice_value"
                                                        name="invoice_value"
                                                        required
                                                        value={formData.invoice_value}
                                                        onChange={(e) => {
                                                            // Allow only numbers and decimal point
                                                            const value = e.target.value;
                                                            const regex = /^[0-9]*\.?[0-9]*$/;

                                                            if (regex.test(value)) {
                                                                handleInputChange(e);
                                                            }
                                                        }}
                                                        readOnly={
                                                            formData.who_paid === "Consignor" &&
                                                            formData.payment_mode === "Invoice Value Method" &&
                                                            formData.consignor_payment_status === "Pay Now" &&
                                                            formData.payment_status === "yes"
                                                        }
                                                    />
                                                </div>

                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="booking_mode" className="form-label">Booking Type <span className="text-danger">*</span></label>
                                                    <select
                                                        className="form-select"
                                                        id="booking_mode"
                                                        name="booking_mode"
                                                        value={formData.booking_mode}
                                                        onChange={handleInputChange}
                                                        required
                                                    // disabled={
                                                    //     formData.who_paid === "Consignor" &&
                                                    //     formData.consignor_payment_status === "Pay Now" &&
                                                    //     formData.payment_status === "Yes" &&
                                                    //     (
                                                    //         formData.payment_mode === "Normal Unit Price Method" ||
                                                    //         formData.payment_mode === "Splitted Unit Price Method"
                                                    //     )
                                                    // }
                                                    >
                                                        <option value="select" disabled>Select Type</option>
                                                        <option value="normal booking">Normal Type</option>
                                                        <option value="split booking">Splited Type</option>
                                                    </select>

                                                </div>
                                            </div>

                                            {formData.booking_mode === 'normal booking' ? (
                                                <div className='row mb-6'>
                                                    <div className="col-md-4 mb-3">
                                                        <label htmlFor="nrml_payment_quantity" className="form-label">Quantity <span className="text-danger">*</span></label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="nrml_payment_quantity"
                                                            name="nrml_payment_quantity"
                                                            value={formData.nrml_payment_quantity === 0 ? '' : formData.nrml_payment_quantity}
                                                            onChange={(e) => {
                                                                let value = e.target.value;

                                                                if (value.length > 1 && value.startsWith("0")) {
                                                                    value = value.replace(/^0+/, "");
                                                                }

                                                                if (/^\d*$/.test(value) || value === "") {
                                                                    handleInputChange(e);
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (
                                                                    e.key === "Backspace" ||
                                                                    e.key === "Delete" ||
                                                                    e.key === "Tab" ||
                                                                    e.key === "Escape" ||
                                                                    e.key === "Enter" ||
                                                                    (e.key >= "0" && e.key <= "9")
                                                                ) {
                                                                    return;
                                                                }
                                                                e.preventDefault();
                                                            }}
                                                            required

                                                            readOnly={
                                                                formData.who_paid === "Consignor" &&
                                                                formData.payment_mode === "Normal Unit Price Method" &&
                                                                formData.consignor_payment_status === "Pay Now" &&
                                                                formData.payment_status === "yes"
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-md-8 mb-3">
                                                        <label htmlFor="notes" className="form-label">Notes</label>
                                                        <textarea
                                                            className="form-control"
                                                            id="notes"
                                                            name="notes"
                                                            value={formData.notes}
                                                            onChange={handleInputChange}
                                                            style={{ height: '38px' }}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div className="row mb-6">
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="large_box_quantity" className="form-label">Large Quantity <span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="large_box_quantity"
                                                                name="large_box_quantity"
                                                                required
                                                                value={formData.large_box_quantity}
                                                                onChange={handleInputChange}
                                                                onKeyDown={(e) => {
                                                                    if (
                                                                        e.key === 'Backspace' ||
                                                                        e.key === 'Delete' ||
                                                                        e.key === 'Tab' ||
                                                                        e.key === 'Escape' ||
                                                                        e.key === 'Enter' ||
                                                                        (e.key >= '0' && e.key <= '9')
                                                                    ) {
                                                                        return;
                                                                    }
                                                                    e.preventDefault();
                                                                }}
                                                                readOnly={
                                                                    formData.who_paid === "Consignor" &&
                                                                    formData.payment_mode === "Splitted Unit Price Method" &&
                                                                    formData.consignor_payment_status === "Pay Now" &&
                                                                    formData.payment_status === "yes"
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="medium_box_quantity" className="form-label">Medium Quantity <span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="medium_box_quantity"
                                                                name="medium_box_quantity"
                                                                required
                                                                value={formData.medium_box_quantity}
                                                                onChange={handleInputChange}
                                                                onKeyDown={(e) => {
                                                                    if (
                                                                        e.key === 'Backspace' ||
                                                                        e.key === 'Delete' ||
                                                                        e.key === 'Tab' ||
                                                                        e.key === 'Escape' ||
                                                                        e.key === 'Enter' ||
                                                                        (e.key >= '0' && e.key <= '9')
                                                                    ) {
                                                                        return;
                                                                    }
                                                                    e.preventDefault();
                                                                }}
                                                                readOnly={
                                                                    formData.who_paid === "Consignor" &&
                                                                    formData.payment_mode === "Splitted Unit Price Method" &&
                                                                    formData.consignor_payment_status === "Pay Now" &&
                                                                    formData.payment_status === "yes"
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="small_box_quantity" className="form-label">Small Quantity <span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="small_box_quantity"
                                                                name="small_box_quantity"
                                                                required
                                                                value={formData.small_box_quantity}
                                                                onChange={handleInputChange}
                                                                onKeyDown={(e) => {
                                                                    if (
                                                                        e.key === 'Backspace' ||
                                                                        e.key === 'Delete' ||
                                                                        e.key === 'Tab' ||
                                                                        e.key === 'Escape' ||
                                                                        e.key === 'Enter' ||
                                                                        (e.key >= '0' && e.key <= '9')
                                                                    ) {
                                                                        return;
                                                                    }
                                                                    e.preventDefault();
                                                                }}
                                                                readOnly={
                                                                    formData.who_paid === "Consignor" &&
                                                                    formData.payment_mode === "Splitted Unit Price Method" &&
                                                                    formData.consignor_payment_status === "Pay Now" &&
                                                                    formData.payment_status === "yes"
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-6'>
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="total_quantity" className="form-label">Total Quantity <span className="text-danger">*</span></label>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                id="total_quantity"
                                                                name="total_quantity"
                                                                value={formData.total_quantity}
                                                                readOnly
                                                            />
                                                        </div>

                                                        <div className="col-md-8 mb-3">
                                                            <label htmlFor="notes" className="form-label">Notes</label>
                                                            <textarea
                                                                className="form-control"
                                                                id="notes"
                                                                name="notes"
                                                                value={formData.notes}
                                                                onChange={handleInputChange}
                                                                style={{ height: '38px' }}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {formData.who_paid === 'Consignor' && (
                                                <>
                                                    <h1 className='card-label formtable fw-bolder fs-3 pb-6'>Consignor Payment</h1>
                                                    <div className="row mb-6">
                                                        <div className="col-md-4 mb-3">
                                                            <label htmlFor="consignor_payment_status" className="form-label">Consignor Payment Status <span className="text-danger">*</span></label>
                                                            <select
                                                                name="consignor_payment_status"
                                                                value={formData.consignor_payment_status || ''}
                                                                onChange={handleInputChange}
                                                                className="form-select"
                                                                required
                                                            // disabled={
                                                            //     formData.consignor_payment_status === 'Pay Now' &&
                                                            //     !!formData.payment_mode
                                                            // }
                                                            >
                                                                <option value="" disabled>Select Consignor Payment Status</option>
                                                                <option value="Pay Now">Pay Now</option>
                                                                <option value="Pay Later">Pay Later</option>
                                                            </select>

                                                        </div>

                                                        {formData.consignor_payment_status === 'Pay Now' && (
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="payment_mode" className="form-label">Payment Method <span className="text-danger">*</span></label>
                                                                <select
                                                                    name="payment_mode"
                                                                    value={formData.payment_mode || ''}
                                                                    onChange={handleInputChange}
                                                                    className="form-select"
                                                                    required
                                                                // disabled={
                                                                //     !!formData.payment_mode &&
                                                                //     formData.payment_status === 'Yes' &&
                                                                //     formData.consignor_payment_status === 'Pay Now'
                                                                // }
                                                                >
                                                                    <option value='' disabled>Select a Payment Method</option>
                                                                    <option value="Piece Rate Method">Piece Rate method</option>
                                                                    <option value="CBM Rate Method">CBM Rate method</option>
                                                                    <option value="Invoice Value Method">Invoice Value Method</option>
                                                                    <option
                                                                        value="Splitted Unit Price Method"
                                                                        disabled={formData.booking_mode?.toLowerCase() === "normal booking"}
                                                                    >
                                                                        Splitted Unit Price Method
                                                                    </option>
                                                                    <option
                                                                        value="Normal Unit Price Method"
                                                                        disabled={formData.booking_mode?.toLowerCase() === "split booking"}
                                                                    >
                                                                        Normal Unit Price Method
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {formData.payment_mode === 'Piece Rate Method' && formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="total_pieces" className="form-label">Piece Count <span className="text-danger">*</span></label>
                                                                <input
                                                                    type='text'
                                                                    name="total_pieces"
                                                                    value={formData.total_pieces}
                                                                    onChange={handleInputChange}
                                                                    className="form-control"
                                                                    // readOnly={
                                                                    //     !!formData.total_pieces &&
                                                                    //     formData.payment_status === 'Yes' &&
                                                                    //     formData.consignor_payment_status === 'Pay Now'
                                                                    // }
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                />

                                                            </div>

                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="piece_value" className="form-label">Price Per Piece <span className="text-danger">*</span></label>
                                                                <input
                                                                    type='text'
                                                                    name="piece_value"
                                                                    value={formData.piece_value}
                                                                    onChange={handleInputChange}
                                                                    // readOnly={
                                                                    //     formData.payment_status === 'Yes' &&
                                                                    //     formData.consignor_payment_status === 'Pay Now'
                                                                    // }
                                                                    className="form-control"
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {formData.payment_mode === 'CBM Rate Method' && formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="cbm_value" className="form-label">CBM <span className="text-danger">*</span></label>
                                                                <input
                                                                    type='text'
                                                                    name="cbm_value"
                                                                    value={formData.cbm_value}
                                                                    onChange={handleInputChange}
                                                                    // readOnly
                                                                    className="form-control"
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label htmlFor="cbm_price" className="form-label">Price Per CBM <span className="text-danger">*</span></label>
                                                                <input
                                                                    type='text'
                                                                    name="cbm_price"
                                                                    value={formData.cbm_price}
                                                                    onChange={handleInputChange}
                                                                    className="form-control"
                                                                    // readOnly
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {formData.payment_mode === 'Invoice Value Method' && formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="invoice_value" className="form-label">Invoice Value <span className="text-danger">*</span></label>
                                                                <input
                                                                    type='text'
                                                                    name="invoice_value"
                                                                    value={formData.invoice_value}
                                                                    onChange={handleInputChange}
                                                                    className="form-control"
                                                                    readOnly
                                                                />
                                                            </div>

                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="invoice_percentage" className="form-label">Invoice Percentage <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    name="invoice_percentage"
                                                                    value={formData.invoice_percentage}
                                                                    onChange={handleInputChange}
                                                                    // readOnly
                                                                    className="form-control"
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            e.key === '.' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {formData.payment_mode === 'Normal Unit Price Method' && formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="row mb-6">
                                                                <div className="col-md-4 mb-3">
                                                                    <label htmlFor="nrml_quantity_price" className="form-label">Unit price <span className="text-danger">*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="nrml_quantity_price"
                                                                        name="nrml_quantity_price"
                                                                        value={formData.nrml_quantity_price}
                                                                        // readOnly
                                                                        onChange={handleInputChange}
                                                                        onKeyDown={(e) => {
                                                                            if (
                                                                                e.key === 'Backspace' ||
                                                                                e.key === 'Delete' ||
                                                                                e.key === 'Tab' ||
                                                                                e.key === 'Escape' ||
                                                                                e.key === 'Enter' ||
                                                                                (e.key >= '0' && e.key <= '9')
                                                                            ) {
                                                                                return;
                                                                            }
                                                                            e.preventDefault();
                                                                        }}
                                                                        required
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {formData.payment_mode === 'Splitted Unit Price Method' && formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="large_unit_price" className="form-label">Large Unit Price <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="large_unit_price"
                                                                    name="large_unit_price"
                                                                    value={formData.large_unit_price}
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                    onChange={handleInputChange}
                                                                // readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="medium_unit_price" className="form-label">Medium Unit Price <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="medium_unit_price"
                                                                    name="medium_unit_price"
                                                                    value={formData.medium_unit_price}
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                    onChange={handleInputChange}
                                                                // readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="small_unit_price" className="form-label">Small Unit Price <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="small_unit_price"
                                                                    name="small_unit_price"
                                                                    value={formData.small_unit_price}
                                                                    onKeyDown={(e) => {
                                                                        if (
                                                                            e.key === 'Backspace' ||
                                                                            e.key === 'Delete' ||
                                                                            e.key === 'Tab' ||
                                                                            e.key === 'Escape' ||
                                                                            e.key === 'Enter' ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault();
                                                                    }}
                                                                    onChange={handleInputChange}
                                                                // readOnly
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                    {formData.consignor_payment_status === 'Pay Now' && (
                                                        <div className="row mb-6">
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="total_price" className="form-label">Total Price <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="total_price"
                                                                    name="total_price"
                                                                    value={formData.total_price}
                                                                    required
                                                                    onChange={handleInputChange}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label className="form-label mb-4">
                                                                    Is the consignor payment done? <span className="text-danger">*</span>
                                                                </label>
                                                                <div>
                                                                    <div className="form-check form-check-inline">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="payment_status"
                                                                            id="payment_status_yes"
                                                                            value="Yes"
                                                                            checked={formData.payment_status === 'Yes'}
                                                                            onChange={(e) => {
                                                                                handleInputChange(e);
                                                                                const totalPrice = formData.total_price;
                                                                                setFormData(prevFormData => ({
                                                                                    ...prevFormData,
                                                                                    total_amount: prevFormData.total_amount || totalPrice,
                                                                                }));
                                                                            }}
                                                                            required
                                                                        // disabled={!!formData.payment_status}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="payment_status_yes">Yes</label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="payment_status"
                                                                            id="payment_status_no"
                                                                            value="No"
                                                                            checked={formData.payment_status === 'No'}
                                                                            onChange={(e) => {
                                                                                handleInputChange(e);
                                                                                setFormData(prevFormData => ({
                                                                                    ...prevFormData,
                                                                                    total_amount: 0,
                                                                                }));
                                                                            }}
                                                                            required
                                                                        // disabled={!!formData.payment_status}
                                                                        />
                                                                        <label className="form-check-label" htmlFor="payment_status_no">No</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor="total_amount" className="form-label">Total Amount <span className="text-danger">*</span></label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    id="total_amount"
                                                                    name="total_amount"
                                                                    value={formData.total_amount !== undefined && formData.total_amount !== 0 ? formData.total_amount : ''}
                                                                    onChange={(e) => {
                                                                        const input = e.target.value;

                                                                        // Allow empty input or valid decimal format
                                                                        if (input === '' || /^\d*\.?\d{0,2}$/.test(input)) {
                                                                            // Check if the value is less than or equal to total_price
                                                                            if (input === '' || input === '.') {
                                                                                setTotalAmountInput(input);
                                                                                if (input === '') {
                                                                                    setFormData(prev => ({ ...prev, total_amount: 0 }));
                                                                                }
                                                                            } else {
                                                                                const value = parseFloat(input);
                                                                                if (!isNaN(value) && value <= formData.total_price) {
                                                                                    setTotalAmountInput(input);
                                                                                    setFormData(prev => ({ ...prev, total_amount: value }));
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        const allowedKeys = [
                                                                            'Backspace',
                                                                            'Delete',
                                                                            'Tab',
                                                                            'Escape',
                                                                            'Enter',
                                                                            '.',
                                                                            'ArrowLeft',
                                                                            'ArrowRight',
                                                                        ];
                                                                        if (
                                                                            allowedKeys.includes(e.key) ||
                                                                            (e.key >= '0' && e.key <= '9')
                                                                        ) {
                                                                            return;
                                                                        }
                                                                        e.preventDefault(); // block anything else
                                                                    }}
                                                                    onBlur={() => {
                                                                        // Format the value with 2 decimal places when the field loses focus
                                                                        if (totalAmountInput && totalAmountInput !== '.') {
                                                                            const formattedValue = parseFloat(totalAmountInput).toFixed(2);
                                                                            setTotalAmountInput(formattedValue);
                                                                        }
                                                                    }}
                                                                    required
                                                                    disabled={formData.payment_status === 'No'}
                                                                />

                                                            </div>
                                                        </div>
                                                    )}


                                                </>


                                            )
                                            }

                                            <div className='d-flex justify-content-end gap-3 mt-3'>
                                                {/* <span className="btn btn-primary">
                                                    Cancel
                                                </span> */}
                                                <button
                                                    type='submit'
                                                    className='btn btn-primary'
                                                    disabled={loading} // Disable button while loading
                                                >
                                                    {!loading && <span className='indicator-label'>Submit</span>}
                                                    {loading && (
                                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                                            Submiting...
                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                        </span>
                                                    )}
                                                </button>

                                            </div>

                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default BookingEdit;